import {
  Box, Typography, Theme, styled,
} from '@material-ui/core';

export const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: '100vh',
});

export const HeaderBox = styled(Box)({
  marginTop: 32,
  marginBottom: 40,
});

export const Title = styled(Typography)({
  marginBottom: 8,
});

export const ErrorText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: 14,
  marginTop: 8,
}));

export const ResendButtonBox = styled(Box)({
  marginTop: 32,
});

export const getResendButtonStyles = (theme: Theme) => ({
  borderRadius: 56,
  backgroundColor: theme.palette.common.white,
  color: theme.palette.text.primary,
  border: `2px solid ${theme.palette.grey[400]}`,
});
